import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { BackButton } from '@components/ui/back-button/back-button';
import {
  AdminMaintenanceService,
} from '@6grain/masofa-monolith-api-client/common/api/adminMaintenance.service';
import {
  HideFieldsOutsideCountryResult,
} from '@6grain/masofa-monolith-api-client/common/model/hideFieldsOutsideCountryResult';

interface MaintenanceCommand {
  id: 'hide-fields-outside-country';
  title: string;
  description: string;
  endpoint: string;
  batchSize: number;
  running: boolean;
  result: HideFieldsOutsideCountryResult | null;
  error: string | null;
}

@Component({
  selector: 'app-maintenance-page',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, ButtonModule, BackButton],
  templateUrl: './maintenance-page.html',
  styleUrl: './maintenance-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenancePageComponent {
  readonly commands: MaintenanceCommand[] = [
    {
      id: 'hide-fields-outside-country',
      title: 'adminMaintenance.hideFields.title',
      description: 'adminMaintenance.hideFields.description',
      endpoint: 'POST /common/AdminMaintenance/HideFieldsOutsideCountry',
      batchSize: 500,
      running: false,
      result: null,
      error: null,
    },
  ];

  constructor(
    private readonly maintenanceService: AdminMaintenanceService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  run(command: MaintenanceCommand): void {
    if (command.running || command.batchSize < 1 || command.batchSize > 5000) {
      return;
    }

    command.running = true;
    command.result = null;
    command.error = null;

    this.maintenanceService.commonAdminMaintenanceHideFieldsOutsideCountryPost({
      batchSize: command.batchSize,
    }).subscribe({
      next: (result) => {
        command.result = result;
        command.running = false;
        this.cdr.markForCheck();
      },
      error: (error: HttpErrorResponse) => {
        command.error = this.formatError(error);
        command.running = false;
        this.cdr.markForCheck();
      },
    });
  }

  formattedResult(result: HideFieldsOutsideCountryResult): string {
    return JSON.stringify(result, null, 2);
  }

  private formatError(error: HttpErrorResponse): string {
    const details = error.error;
    if (typeof details === 'string' && details.trim()) {
      return details;
    }
    if (details?.detail) {
      return details.detail;
    }
    if (details?.title) {
      return details.title;
    }
    return `${error.status || ''} ${error.statusText || 'Request failed'}`.trim();
  }
}
